module.exports = __webpack_public_path__ + "img/event_day3_1000.9f0e470a.png";